import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { PackageSizesResp } from '@marketplace-web/domain/item-upload-data'

import { updateUserBundleDiscountsArgsToParams } from '../transformers/bundle-discounts'
import { UpdateUserBundleDiscountsArgs } from '../types/bundle-discounts'
import { GetUserBundleItemsArgs, UserBundleItemsResp } from '../types/bundle-items'
import { BundleOrderReviewArgs, GetBundleOrderReviewResp } from '../types/bundle-order-review'
import { BundleSummaryResp } from '../types/bundle-summary'
import {
  CreateBundleTransactionArgs,
  CreateBundleTransactionResp,
  EditBundleTransactionArgs,
  GetTransactionPackageSizesArgs,
  SelectTransactionPackageSizeArgs,
} from '../types/bundle-transaction'
import { CustomShipmentConfigResp } from '../types/shipment-custom-config'

type createBundleSummaryArgs = {
  itemIds: Array<number>
  sellerId: number
}

export const createBundleSummary = ({ itemIds, sellerId }: createBundleSummaryArgs) =>
  api.post<BundleSummaryResp>(
    '/bundle_summary',
    {
      item_ids: itemIds,
      seller_id: sellerId,
    },
    {
      headers: moneyObjectHeader,
    },
  )

export const getBundleOrderReview = ({ itemIds, sellerId }: BundleOrderReviewArgs) =>
  api.post<GetBundleOrderReviewResp>('/bundle_order_review', {
    item_ids: itemIds,
    seller_id: sellerId,
  })

export const createBundleTransaction = ({
  selectedItemIds,
  bundleTrackingId,
  bundleShippingType,
}: CreateBundleTransactionArgs) =>
  api.post<CreateBundleTransactionResp>(
    '/bundles',
    {
      item_ids: selectedItemIds,
      bundle_id: bundleTrackingId,
      bundle_shipping_type: bundleShippingType,
    },
    { headers: moneyObjectHeader },
  )

export const editBundleTransaction = ({
  transactionId,
  selectedItemIds,
  bundleTrackingId,
  bundleShippingType,
}: EditBundleTransactionArgs) =>
  api.put<CreateBundleTransactionResp>(
    `/transactions/${transactionId}/bundle`,
    {
      item_ids: selectedItemIds,
      bundle_id: bundleTrackingId,
      bundle_shipping_type: bundleShippingType,
    },
    { headers: moneyObjectHeader },
  )

export const getUserBundleItems = ({
  userId,
  preselectedItemIds,
  currentPage,
  perPage,
}: GetUserBundleItemsArgs) =>
  api.get<UserBundleItemsResp>('/bundles/items', {
    params: {
      user_id: userId,
      page: currentPage + 1,
      per_page: perPage,
      item_ids: preselectedItemIds,
    },
    headers: moneyObjectHeader,
  })

export const updateUserBundleDiscounts = (args: UpdateUserBundleDiscountsArgs) =>
  api.put(
    `/users/${args.userId}/multitier_bundle_discount`,
    updateUserBundleDiscountsArgsToParams(args),
  )

export const getTransactionPackageSizes = ({ transactionId }: GetTransactionPackageSizesArgs) =>
  api.get<PackageSizesResp>(`/transactions/${transactionId}/package_sizes`)

export const selectTransactionPackageSize = ({
  transactionId,
  packageSizeId,
  customShipmentPrice,
}: SelectTransactionPackageSizeArgs) =>
  api.put(`/transactions/${transactionId}/package_size`, {
    package_size_id: packageSizeId,
    custom_shipment_price: customShipmentPrice,
  })

export const getCustomShipmentConfig = () =>
  api.get<CustomShipmentConfigResp>('/configurations/custom_shipment', {
    headers: moneyObjectHeader,
  })
